import styled from "styled-components";
import { satoshi700 } from "../../../../../styles/font.constants";

export const PollQuestion = styled.div`
	${satoshi700}
	font-size: 1rem;
	margin-top: 0.5rem;
`;

export const PollOptions = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.3rem;
	margin: 1.3rem 0;
`;
